<template>
   <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.memberList") }}</h1>
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="10">
        <el-row :gutter="10">
          <el-col :span="15">
            <el-input
            :placeholder="$locale('membership.memberList.searchPlaceholder')"
            v-model="filter.name"
            @keyup.enter.native="filter_fn"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn"></i>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="filter_fn">{{
              $locale("global.confirm2")
            }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="14" class="search-item ta-r">
        <el-button @click="exportCsv_fn()" class="egl-btn-yellow">{{ $locale("global.exportToCSV") }}</el-button>
      </el-col>
    </el-row>
    <!-- Table -->
    <el-table
      ref="listTable"
      :data="tableData"
      class="egl-table list-table"
      stripe
      @filter-change="filterChange_fn"
      @sort-change="sortChange_fn"
    >
      <el-table-column prop="memberNum" :label="$locale('membership.coupon.memberID')" align="center"></el-table-column>
      <el-table-column prop="chineseFullName" :label="$locale('global.name')" align="center"></el-table-column>
      <el-table-column prop="email" :label="$locale('membership.memberList.dialog.personal.email')" align="center"></el-table-column>
      <el-table-column prop="memberShipId"
        :label="$locale('membership.coupon.memberType')"
        align="center"
        :filters="memberTypeList"
        :filter-multiple="false"
        column-key="memberShipId"
        :formatter="(row, column, cellValue, index) => (memberTypeList.find(item => item.value === cellValue) || {}).text"
      ></el-table-column>
      <el-table-column prop="memberShipRankId"
        :label="$locale('membership.coupon.rank')"
        align="center"
        :filters="rankFilters"
        :key="rankFilters ? rankFilters.length : 0"
        :formatter="getRankName"
        column-key="memberShipRankId"
      ></el-table-column>
      <el-table-column prop="totalViews" :label="$locale('membership.memberList.viewNumbers')"></el-table-column>
      <el-table-column prop="totalCost"
        :label="$locale('membership.coupon.consumption')"
        align="center"
        sortable="custom"
        :formatter="(row, column, cellValue, index) => '¥' + priceFormatter(cellValue)"
      ></el-table-column>
      <el-table-column prop="needMoreViews" :label="$locale('membership.memberList.upgradesLeft')"></el-table-column>
      <el-table-column
        prop="joinTime"
        :label="$locale('membership.coupon.enrollmentDate')"
        align="center"
        sortable="custom"
        :formatter="(row, column, cellValue, index) =>
        cellValue > 0 ? $moment(cellValue).format('YYYY/MM/DD') : ''"
      ></el-table-column>
      <el-table-column
        prop="expireTime"
        :label="$locale('memberShip.log.expiredTime')"
        align="center"
        sortable="custom"
        :formatter="(row, column, cellValue, index) =>
        cellValue > 0 ? $moment(cellValue).format('YYYY/MM/DD') : '期限なし'"
        ></el-table-column>
      <el-table-column prop="memberStatus"
        :label="$locale('membership.memberList.status')"
        align="center"
        :filters="statusList"
        column-key="memberStatus"
        :formatter="(row, column, cellValue, index) => (statusList.find(item => item.value === cellValue) || {}).text"
      ></el-table-column>
      <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <div class="handle">
              <a @click="getDetail(scope.row.id, 'detail')">{{ $locale('global.detail') }}</a>
               <el-divider direction="vertical"></el-divider>
              <a :class="{ 'disabled-link': isDisableEditBtn() }" @click="!isDisableEditBtn() && getDetail(scope.row.id, 'edit')">{{ $locale('global.edit') }}</a>
            </div>
          </template>
        </el-table-column>
    </el-table>
    <CommPagination
      :total="count"
      :curPage="currentPage"
      @current-change="pageChange"
      :pageSize="20"
      style="height: 34px;margin-right: 0;"
    />
    <!-- Dialog -->
    <Dialog :isOpen.sync="isDialogOpen" ref="dialog" @close="isDisable = false" />
  </div>
</template>
<script>
import CommPagination from "@/components/common/CommPagination";
import Dialog from '@/components/MemberShip/MemberList/Dialog.vue'
import { getCinemaList } from "@/helpers/service/api/common";
import { getMemberListService, getMemberShipOptionListService, getMemberDetailService, getCouponListMapService } from "@/helpers/service/api/membership"
import { priceFormatter, getMemberStatus } from "@/assets/js/membership"
import { exportCSV_fn } from '@/assets/js/memberList_exportCSV'
export default {
  provide() {
    return {
      getList_fn: this.getList,
      getListDetail_fn: this.getDetail,
      memberShipList: () => this.originMemberTypeList,
      isDeatilDisable: () => this.isDisable,
      cinemaList: () => this.cinemaList,
      couponOptionList: () => this.couponOptionList,
      memberTypeList: () => this.memberTypeList,
      rankTypeList: () => this.rankTypeList,
    }
  },
  data() {
    return {
      filter: {
        name: "",
        memberShipId: "",
        memberShipRankId: [],
        curSortType: "",
        curSortKey: "",
        memberStatus: [],
      },
      exportCsv(){},
      tableData: [],
      memberTypeList: [],
      originMemberTypeList: [],
      rankTypeList: [],
      cinemaList: [],
      couponOptionList: [],
      statusList: getMemberStatus().filter((item) => item.value !== 'delete'),
      isDialogOpen: false,
      priceFormatter,
      exportCSV_fn,
      count: 0,
      currentPage: 0,
      isDisable: false,
    }
  },
  computed: {
    rankFilters() {
      return this.getMemberShipRankFilterList_fn();
    }
  },
  async created() {
    await getCinemaList({
      page: 0,
      pageSize: 99999,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.cinemaList = res.data.data
      }
    })
    await getCouponListMapService({ brandId: window.localStorage.getItem("brandId") }).then(res => {
      if (res.data && res.data.length > 0) {
        this.couponOptionList = res.data;
      }
    })
    await getMemberShipOptionListService({
      brandId: window.localStorage.getItem("brandId")
    }).then(res => {
      this.originMemberTypeList = res.data
      this.memberTypeList = res.data ?
      res.data.map(item => ({
        text: item.name,
        value: item.id
      })): []
      this.getList()
    })
  },
  methods: {
    filter_fn() {
      this.currentPage = 0
      this.getList()
    },
    hasExportPermission() {
      try {
        const curPermission = window.localStorage.getItem("permissionMap");
        if (!curPermission) return false;
        const permissionMap = JSON.parse(curPermission);
        return permissionMap.cl_membership && permissionMap.cl_membership.types &&
          permissionMap.cl_membership.types.includes("export");
      } catch (e) {
        return false;
      }
    },
    exportCsv_fn() {
      const self = this;
      const doExport = function(includeAddress) {
        const requestParma = {
          brandId: window.localStorage.getItem("brandId"),
          ...self.filter.name ? { keyword: self.filter.name } : {},
          ...self.filter.memberShipId ? { membershipName: self.filter.memberShipId } : {},
          ...self.filter.memberShipRankId.length > 0 ? { membershipRankName: self.filter.memberShipRankId } : {},
          ...self.filter.memberStatus.length > 0 ? { memberStatus: self.filter.memberStatus } : {},
          ...self.filter.curSortKey ? { sortKey: self.filter.curSortKey } : {},
          ...self.filter.curSortType ? { sortType: self.filter.curSortType } : {},
          page: 0,
          pageSize: 999999,
          includeAddress: includeAddress
        };
        exportCSV_fn(requestParma, self.originMemberTypeList, self.memberTypeList);
      };
      if (this.hasExportPermission()) {
        this.$confirm(
          "個人情報保護のため、住所を含むCSVをエクスポートする場合は、利用目的の確認と安全な保管・不要時の削除をお願いします。",
          "CSVエクスポート",
          {
            confirmButtonText: "住所を含む",
            cancelButtonText: "基本情報のみ",
            distinguishCancelAndClose: true,
            type: "warning"
          }
        ).then(() => {
          doExport(true);
        }).catch(action => {
          if (action === "cancel") {
            doExport(false);
          }
        });
      } else {
        doExport(false);
      }
    },
    openDialog() {
      this.isDialogOpen = true;
      this.$refs["dialog"].formObj = {
        basic: {
          id: "202006101353",
          status: "常連客",
          enrollmentDate: "2019.01.02",
          favoriteGenre: ["SF", "青春", "恋愛", "SF", "青春", "恋愛"],
          amount: "¥20,000",
          favTheater: "シネマランド東京 , シネマランド品川",
        },
        information: {
          type: "有料会員",
          rank: "ゴールド",
          expiredDate: "2023.01.02",
          enrollmentDate: "2022.01.02",
        },
        personal: {
          name: "山田 太郎",
          furigana: "フリガナ",
          gender: "男性",
          birthday: "1993.01.23",
          telNumber: "08012345678",
          email: "aaa@eigaland.com",
          streetAddress: "123 - 1234 東京都中央区"
        },
        history: {}
      }
    },
    getList() {
      this.$forceUpdate();
      getMemberListService({
        brandId: window.localStorage.getItem("brandId"),
        ...this.filter.name ? { keyword: this.filter.name } : {},
        ...this.filter.memberShipId ? { memberShipId: this.filter.memberShipId } : {},
        ...this.filter.memberShipRankId.length > 0 ? { memberShipRankId: this.filter.memberShipRankId } : {},
        ...this.filter.memberStatus.length > 0 ? { memberStatus: this.filter.memberStatus } : {},
        ...this.filter.curSortKey ? { sortKey: this.filter.curSortKey } : {},
        ...this.filter.curSortType ? { sortType: this.filter.curSortType } : {},
        page: this.currentPage,
        pageSize: 20
      }).then(res => {
        this.count = res.data.count;
        if (res.data) {
          this.tableData = res.data.data
        } else {
          this.tableData = []
        }
      })
    },
    pageChange(value) {
      if (!value) { return; }
      this.currentPage = value - 1;
      this.getList();
    },
    filterChange_fn(filters) {
      console.log(filters)
      if (filters.memberShipId) {
        this.$refs.listTable.clearFilter("memberShipRankId")
        const curMemberShipID = filters.memberShipId[0]
        this.filter.memberShipId = curMemberShipID
        this.filter.memberShipRankId = []
      } else if (filters.memberShipRankId) {
        this.filter.memberShipRankId = filters.memberShipRankId
      } else if (filters.memberStatus) {
        this.filter.memberStatus = filters.memberStatus
      }
      this.currentPage = 0;
      this.getList();
    },
    getMemberShipRankFilterList_fn() {
      if (!this.filter.memberShipId) return null;
      const curRankList = (this.originMemberTypeList.find(item => item.id === this.filter.memberShipId) || {}).rankList
      return (curRankList && curRankList.length > 0) ? curRankList.map(item => ({
          text: item.name,
          value: item.uuid
        })) : null
    },
    sortChange_fn(sort) {
      this.filter.curSortKey = sort.prop
      this.filter.curSortType = sort.order === "ascending" ? "ASC" : "DESC"
      this.getList()
    },
    getDetail(id, type) {
      getMemberDetailService({
        userId: id
      }).then(res => {
        this.isDialogOpen = true;
        this.$refs.dialog.formObj = res.data
        this.isDisable = type === "detail"
      })
    },
    getRankName(row, column, cellValue, index) {
      const curRankList = (this.originMemberTypeList.find(item => item.id === row.memberShipId) || {}).rankList
      return curRankList && curRankList.length > 0 ? (curRankList.find(rank => rank.uuid === cellValue) || {}).name : ""
    },
    isDisableEditBtn() {
      const curPermission = window.localStorage.getItem("permissionMap");
      if (!curPermission) {
        return false;
      }
      const permissionMap = JSON.parse(curPermission);
      const isHaveEdit = permissionMap.cl_membership.types.includes("edit");
      return !isHaveEdit;
    },
  },
  components: {
    CommPagination,
    Dialog
  },
}
</script>
<style scoped>
.disabled-link {
  color: #999999 !important;
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  text-decoration: none !important;
}

.disabled-link:hover {
  color: #999999 !important;
  text-decoration: none !important;
}
</style>
